import apiurl from './apiurl';

//import React from 'react'
import axios from 'axios';


const obj= {
    getDevices: async (idToken) =>        
    axios({
        'method':'GET',
        'url':apiurl +'monitor',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    })
    
};

export default obj;

    
  